// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'




import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//测试
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

//vuex
import store from './store';

Vue.prototype.IMG = 'https://www.verygrass.mo/index.php/api/images' //
// Vue.prototype.IMG = 'http://test1.verygrass.mo/index.php/api/images' //
// Vue.prototype.IMG = 'http://119.28.25.73/api/images' // 测试


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js